/**
 * https://www.froala.com/wysiwyg-editor/docs/options#tableEditButtons
 */
export default {
  tableEditButtons: [
    'tableHeader',
    'tableRemove',
    '|',
    'tableRows',
    'tableColumns',
    // 'tableStyle',
    '-',
    'tableCells',
    // 'tableCellBackground',
    'tableCellVerticalAlign',
    'tableCellHorizontalAlign',
    // 'tableCellStyle'
  ]
};
